<template>
  <div class="pageLoader">
    <div class="popup_in center">
      <vue-loaders-ball-rotate color="#30448d" />
    </div>
  </div>
</template>

<script>
export default {
  name: "PageLoader"
};
</script>

<style scoped></style>
